import React from 'react';
import { i18nTranslateOrFallback } from '../../../util';
import PropTypes from 'prop-types';

const ScopeServices = ({ scopeServices, i18n }) => {
  return scopeServices.map(({ scope, services }) => (
    <div key={scope}>
      {services.length > 0 && (
        <>
          <div className='subheading'>{i18n.t(`mig.scope.${scope}.title`)}</div>
          <ul style={{ marginBottom: '1em' }}>
            {services.map(({ code }, idx) => (
              <span key={code}>
                {i18nTranslateOrFallback(i18n, `onp.serviceCode.${code}.description`, code)}
                {idx === services.length - 1 ? '' : ', '}
              </span>
            ))}
          </ul>
        </>
      )}
    </div>
  ));
};

ScopeServices.propTypes = {
  scopeServices: PropTypes.array,
  i18n: PropTypes.object,
};

export default ScopeServices;
